import { useMutation, useQuery, useQueryClient } from "react-query";
import qs from "qs-lite";
import api from "../../utils/api";
import { invalidate } from "../../helpers/clientHelper";
import { useHubSnackBar } from "../useSnackBar";

export const CALENDAR = "/calendar";
const CALENDAR_GOALS = `${CALENDAR}/goals`;
const CALENDAR_CLOSED = `${CALENDAR}/closed`;

const getCalendarData = ({ queryKey }) => {
    const queryString = qs.stringify(queryKey[1]);
    return api.get(`${CALENDAR}?${queryString}`);
};

export const useGetCalendarData = ({ location = 1, month, year }) => {
    const today = new Date();
    const defaultYear = today.getFullYear();
    const defaultMonth = today.getMonth() + 1;

    const queryProps = {
        location,
        month: isNaN(month) ? defaultMonth : month + 1,
        year: isNaN(year) ? defaultYear : year,
    };

    return useQuery([CALENDAR, { ...queryProps }], getCalendarData);
};

// ── Location Goals ──
const getLocationGoals = ({ queryKey }) =>
  api.get(`${CALENDAR_GOALS}/${queryKey[1]}`);

export const useGetLocationGoals = (locationId) =>
  useQuery([CALENDAR_GOALS, locationId], getLocationGoals, {
    enabled: !!locationId,
  });

export const usePutLocationGoals = () => {
  const queryClient = useQueryClient();
  const { addSnackbarSuccess } = useHubSnackBar();
  return useMutation(
    ({ locationId, ...body }) => api.put(`${CALENDAR_GOALS}/${locationId}`, body),
    {
      onSuccess: (_, { locationId }) => {
        invalidate(queryClient, CALENDAR_GOALS);
        invalidate(queryClient, CALENDAR);
        addSnackbarSuccess({ message: "Goals updated" });
      },
    },
  );
};

// ── Closed Dates ──
const getClosedDates = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1]);
  return api.get(`${CALENDAR_CLOSED}?${queryString}`);
};

export const useGetClosedDates = ({ location, startDate, endDate }) =>
  useQuery(
    [CALENDAR_CLOSED, { location, startDate, endDate }],
    getClosedDates,
    { enabled: !!location && !!startDate && !!endDate },
  );

export const useAddClosedDate = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (body) => api.post(CALENDAR_CLOSED, body),
    { onSuccess: () => invalidate(queryClient, CALENDAR_CLOSED) },
  );
};

export const useRemoveClosedDate = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (id) => api.delete(`${CALENDAR_CLOSED}/${id}`),
    { onSuccess: () => invalidate(queryClient, CALENDAR_CLOSED) },
  );
};